import axios from "axios";
import { beforeRequestHandler, requestErrorHandler, } from "./HandleGlobalInterceptors";
import config from "@/config";
var instanceV1 = axios.create({ baseURL: config.authX360UrlV1 });
var APIInstanceAuthX360 = /** @class */ (function () {
    function APIInstanceAuthX360(instance) {
        var _this = this;
        this.registerGlobalRequestInterceptors = function () {
            _this.instance.interceptors.request.use(beforeRequestHandler, requestErrorHandler);
            _this.instance.interceptors.response.use(undefined, function (error) {
                return requestErrorHandler(error, instanceV1);
            });
        };
        this.instance = instance;
        this.registerGlobalRequestInterceptors();
    }
    Object.defineProperty(APIInstanceAuthX360.prototype, "buffedInstances", {
        get: function () {
            return this.instance;
        },
        enumerable: false,
        configurable: true
    });
    APIInstanceAuthX360.prototype.setAuthorizationToken = function (token) {
        try {
            this.instance.defaults.headers["Authorization"] = "Bearer ".concat(token);
        }
        catch (error) {
            console.error("Failed to set authorization token: ".concat(error));
        }
    };
    return APIInstanceAuthX360;
}());
var _MPInstanceAuthX360 = null;
export var MPInstanceAuthX360 = {
    get buffedInstances() {
        if (!_MPInstanceAuthX360) {
            _MPInstanceAuthX360 = new APIInstanceAuthX360(instanceV1);
        }
        return _MPInstanceAuthX360.buffedInstances;
    },
    setAuthorizationToken: function (token) {
        if (!_MPInstanceAuthX360) {
            _MPInstanceAuthX360 = new APIInstanceAuthX360(instanceV1);
        }
        return _MPInstanceAuthX360.setAuthorizationToken(token);
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVxdWVzdEF4aW9zQXV0aFgzNjAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJSZXF1ZXN0QXhpb3NBdXRoWDM2MC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUF3QixNQUFNLE9BQU8sQ0FBQztBQUM3QyxPQUFPLEVBQ0wsb0JBQW9CLEVBQ3BCLG1CQUFtQixHQUNwQixNQUFNLDRCQUE0QixDQUFDO0FBQ3BDLE9BQU8sTUFBTSxNQUFNLFVBQVUsQ0FBQztBQUU5QixJQUFNLFVBQVUsR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFDLEVBQUUsT0FBTyxFQUFFLE1BQU0sQ0FBQyxhQUFhLEVBQUUsQ0FBQyxDQUFDO0FBRW5FO0lBR0UsNkJBQVksUUFBdUI7UUFBbkMsaUJBR0M7UUFjTyxzQ0FBaUMsR0FBRztZQUMxQyxLQUFJLENBQUMsUUFBUSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUNwQyxvQkFBb0IsRUFDcEIsbUJBQW1CLENBQ3BCLENBQUM7WUFDRixLQUFJLENBQUMsUUFBUSxDQUFDLFlBQVksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLFNBQVMsRUFBRSxVQUFDLEtBQUs7Z0JBQ3ZELE9BQUEsbUJBQW1CLENBQUMsS0FBSyxFQUFFLFVBQVUsQ0FBQztZQUF0QyxDQUFzQyxDQUN2QyxDQUFDO1FBQ0osQ0FBQyxDQUFDO1FBeEJBLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO1FBQ3pCLElBQUksQ0FBQyxpQ0FBaUMsRUFBRSxDQUFDO0lBQzNDLENBQUM7SUFFRCxzQkFBVyxnREFBZTthQUExQjtZQUNFLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQztRQUN2QixDQUFDOzs7T0FBQTtJQUVNLG1EQUFxQixHQUE1QixVQUE2QixLQUFhO1FBQ3hDLElBQUk7WUFDRixJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsZUFBZSxDQUFDLEdBQUcsaUJBQVUsS0FBSyxDQUFFLENBQUM7U0FDckU7UUFBQyxPQUFPLEtBQUssRUFBRTtZQUNkLE9BQU8sQ0FBQyxLQUFLLENBQUMsNkNBQXNDLEtBQUssQ0FBRSxDQUFDLENBQUM7U0FDOUQ7SUFDSCxDQUFDO0lBV0gsMEJBQUM7QUFBRCxDQUFDLEFBN0JELElBNkJDO0FBRUQsSUFBSSxtQkFBbUIsR0FBK0IsSUFBSSxDQUFDO0FBRTNELE1BQU0sQ0FBQyxJQUFNLGtCQUFrQixHQUFHO0lBQ2hDLElBQUksZUFBZTtRQUNqQixJQUFJLENBQUMsbUJBQW1CLEVBQUU7WUFDeEIsbUJBQW1CLEdBQUcsSUFBSSxtQkFBbUIsQ0FBQyxVQUFVLENBQUMsQ0FBQztTQUMzRDtRQUNELE9BQU8sbUJBQW1CLENBQUMsZUFBZSxDQUFDO0lBQzdDLENBQUM7SUFFRCxxQkFBcUIsWUFBQyxLQUFhO1FBQ2pDLElBQUksQ0FBQyxtQkFBbUIsRUFBRTtZQUN4QixtQkFBbUIsR0FBRyxJQUFJLG1CQUFtQixDQUFDLFVBQVUsQ0FBQyxDQUFDO1NBQzNEO1FBQ0QsT0FBTyxtQkFBbUIsQ0FBQyxxQkFBcUIsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxRCxDQUFDO0NBQ0YsQ0FBQyJ9